// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-DateTimeCell_cls1__rdiXS","cls2":"VeloTable-DateTimeCell_cls2__trmD- VeloTable-DateTimeCell_cls1__rdiXS"};